import { axiosInstance as axios } from "./interceptor";
import { getURLFunc } from "./apiUtils";

export interface SupportedLanguage {
  code: string;
  description: string;
}
export interface SupportedLanguages {
  languages: SupportedLanguage[];
}

const getUrl = getURLFunc("/api/languages/supported");

export function getSupportedLanguages() {
  return axios.get<SupportedLanguages>(getUrl(``)).then(r => r.data.languages);
}
